import { apiPaths } from "../utils/apiUtils";
import qs from 'qs';
import api from "./api";

/**
 * Fetch applications
 * @param {Object} params - Query parameters for API request.
 * @param {AbortSignal} signal - Optional signal to cancel the request.
 * @returns {Promise<Object|null>} - Applications data or null if an error occurs.
 */
export async function getApplications(params) {
  try {
    console.log("Frontend: Sending request with params:", params);
    const response = await api.get(`${apiPaths.application}`, {
      params: { ...params },
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" })
    });

    if (!response || !response.data) {
      throw new Error("Invalid response structure");
    }

    return response?.data;
  } catch (error) {
    throw handleApiError(error)
  }
}

export async function getApplicationByIDApi(applicationId) {
  try {
    const response = await api.get(`${apiPaths.application}/${applicationId}`);
    console.log(`**get-application-of-${applicationId}**`, response);

    if (!response || !response.data) {
      throw new Error("Invalid response structure");
    }

    return response.data;
  } catch (error) {
    throw handleApiError(error)
  }
}

export const getApplicationsByStatusApi = async (status) => {
  try {
    const response = await api.get(`${apiPaths.application}`, { params: { applicationStatus: status } });
    console.log(`**get-applications-by-status-${status}**`, response);

    if (!response || !response.data) {
      throw new Error("Invalid response structure");
    }

    return response?.data?.data;
  } catch (error) {
    handleApiError(error, "Fetching Application by ApplicationStatus")
    throw error;
  }
};

export const getMvSorData = async (applicationId) => {
  try {
    const response = await api.get(`${apiPaths.application}/${applicationId}/sor`);
    if (!response || !response.data) {
      throw new Error("Invalid response structure");
    }

    console.log("MvSorData Api Response: ", response?.data);
    return response?.data;
  } catch (error) {
    console.error("Error calling getMvSorData API:", error);
    throw error;
  }
}

export async function OAuthGetUserDataApi() {
  try {
    const response = await api.get(`${apiPaths.Oauth}/user`);

    if (response) {
      return response
    } else {
      console.error("Error occurred in response");
      return null;
    }
  } catch (error) {
    console.error("Error fetching OAUTH user data", error);
    return null;
  }
}

/**
 * Centralized error handler for API calls.
 * @param {Error} error - The caught error.
 * @param {string} context - Context message for debugging.
 */
function handleApiError(error, context) {
  
  const errorData = error?.response?.data;
  const status = error?.status;
  const errorMessage = errorData?.message || error?.message;

  console.log("Error in getApplications API:", errorData);
  console.error(`[API Error]: ${context} - Status: ${status || "N/A"}, Message: ${errorMessage}, Error Data: ${errorData}`);

  return errorData || errorMessage; // Include error from Backend if available otherwise error message
}
